export default __webpack_public_path__ + "media/src/images/assign_route/assign-10b7dee52e3c4cce3cdb0efdd046c9cb.svg";